import { render, staticRenderFns } from "./H5NewView.vue?vue&type=template&id=3c2b2d99&scoped=true"
import script from "./H5NewView.vue?vue&type=script&lang=js"
export * from "./H5NewView.vue?vue&type=script&lang=js"
import style0 from "./H5NewView.vue?vue&type=style&index=0&id=3c2b2d99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2b2d99",
  null
  
)

export default component.exports